const maxHeight = 640
const minHeight = 200
const paddings = 75 * 2 + 64 + 79

export const getTreeHeight = () =>
  Math.max(Math.min(window.innerHeight - paddings, maxHeight), minHeight)
